import Settings from './settings.container';

export default Settings;
